package amazon.lastmile.inject

import app.nestbridge.feature.children.ui.CreateChildProfileUiFactory
import com.slack.circuit.runtime.ui.Ui
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = CreateChildProfileUiFactory::class)
public interface AppNestbridgeFeatureChildrenUiCreateChildProfileUiFactory {
  @Provides
  @IntoSet
  public fun provideCreateChildProfileUiFactoryFactoryMultibinding(createChildProfileUiFactory: CreateChildProfileUiFactory): Ui.Factory = createChildProfileUiFactory
}
